import React from 'react'
import { styled } from '@mui/material/styles'
import { useTranslation } from 'react-i18next'

import { Tooltip, Menu, MenuItem, IconButton as MuiIconButton } from '@mui/material'
import { useLanguagePreference } from '../../hooks/useLanguagePreference'
import { resolveLanguage } from '../../i18n/languagePreference'

const IconButton = styled(MuiIconButton)`
    svg {
        width: 22px;
        height: 22px;
    }
`

const Flag = styled('img')`
    border-radius: 50%;
    width: 20px;
    height: 20px;
`

const languageOptions = {
    sv: {
        icon: '/static/img/flags/se.png',
        name: 'Svenska',
    },
    en: {
        icon: '/static/img/flags/us.png',
        name: 'English',
    },
}

function NavbarLanguagesDropdown() {
    const { t } = useTranslation()
    const { language, setLanguage } = useLanguagePreference()
    const [anchorMenu, setAnchorMenu] = React.useState(null)
    const activeLanguage = resolveLanguage(language)
    const selectedLanguage = languageOptions[activeLanguage] ?? languageOptions.sv

    const toggleMenu = (event) => {
        setAnchorMenu(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorMenu(null)
    }

    const handleLanguageChange = (nextLanguage) => {
        void setLanguage(nextLanguage)
        closeMenu()
    }

    return (
        <React.Fragment>
            <Tooltip title={t('site.nav.language')}>
                <IconButton
                    aria-owns={anchorMenu ? 'menu-appbar' : undefined}
                    aria-haspopup='true'
                    onClick={toggleMenu}
                    color='inherit'
                    size='large'
                >
                    <Flag src={selectedLanguage.icon} alt={selectedLanguage.name} />
                </IconButton>
            </Tooltip>
            <Menu id='menu-appbar' anchorEl={anchorMenu} open={Boolean(anchorMenu)} onClose={closeMenu}>
                {Object.keys(languageOptions).map((languageOption) => (
                    <MenuItem
                        key={languageOption}
                        selected={languageOption === activeLanguage}
                        onClick={() => handleLanguageChange(languageOption)}
                    >
                        {languageOptions[languageOption].name}
                    </MenuItem>
                ))}
            </Menu>
        </React.Fragment>
    )
}

export default NavbarLanguagesDropdown
